var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"pagination__link",attrs:{"aria-label":_vm.ariaLabel},on:{"click":_vm.handlePageClick}},[_vm._v(" "+_vm._s(_vm.page)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }